import React from "react";
import "./StartingScreen.css";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";
/** Firebase Imports **/
/** **/
const StartingScreen = () => {
	const navigate = useNavigate();

	return (
		<div className="h-full w-full m-0 p-0">
			<div className="truck-image h-5/6 w-full flex justify-center">
				<img
					src={require("../../images/backgroundOverlayNew.png")}
					alt="overlay_image"
					className="truck_overlay"
				/>
			</div>
			<div className="buttons h-1/6 flex items-center justify-evenly">
				<Button
					className={""}
					title={"Login"}
					mode={"outlined"}
					size={"md"}
					onClick={() => {
						navigate("/login");
					}}
				/>
				<Button
					className={""}
					title={"Register"}
					mode={"filled"}
					size={"md"}
					onClick={() => {
						navigate("/register");
					}}
				/>
			</div>
		</div>
	);
};

export default StartingScreen;
